var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSecurePayment = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M3.508 14a3.65 3.65 0 0 1 3.65-3.65h33.685a3.65 3.65 0 0 1 3.65 3.65v9.771h-1.3v-9.77a2.35 2.35 0 0 0-2.35-2.35H7.157A2.35 2.35 0 0 0 4.808 14v20.958a2.35 2.35 0 0 0 2.35 2.35H31.76v1.3H7.158a3.65 3.65 0 0 1-3.65-3.65z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "m37.974 23.853.342 1.254-5.626 1.534v5.29l.008.101a10.7 10.7 0 0 0 .307 1.726c.284 1.07.798 2.305 1.705 3.177.99.952 1.92 1.597 2.599 2.002a10 10 0 0 0 1.012.532l.05.021.01.005-.236.605-.237.605h-.002l-.002-.002-.007-.002-.02-.009-.073-.03a7 7 0 0 1-.258-.12c-.22-.105-.53-.265-.904-.489a16 16 0 0 1-2.833-2.18c-1.154-1.11-1.75-2.61-2.06-3.781a12 12 0 0 1-.346-1.95l-.01-.128-.002-.036v-.015l.649-.03-.65.03v-6.315z",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "m37.908 23.853-.342 1.254 5.626 1.534v5.29l-.008.101a10.703 10.703 0 0 1-.307 1.726c-.284 1.07-.798 2.305-1.705 3.177-.99.952-1.92 1.597-2.599 2.002a10 10 0 0 1-1.012.532l-.05.021-.01.005.236.605.237.605h.002l.002-.002.006-.002.022-.009.072-.03q.093-.04.258-.12c.22-.105.529-.265.904-.489.749-.447 1.761-1.15 2.833-2.18 1.154-1.11 1.75-2.61 2.06-3.781a12 12 0 0 0 .346-1.95l.01-.128.002-.036v-.015000000000000001l-.649-.03.65.03v-6.3149999999999995zM43.842 17.507H4.416v-1.3h39.426zM4.416 21.152h39.426v1.3H4.416zM24 27.748H8.754v-1.3H24zM18.396 32.072H8.753v-1.3h9.641z",
  clipRule: "evenodd"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "m41.906 29.969-4.288 4.287-2.985-2.986.92-.92 2.066 2.067 3.367-3.368z",
  clipRule: "evenodd"
})));
export { SvgSecurePayment as ReactComponent };
export default "/_next/static/images/securePayment.svg";